"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _immutable = require("immutable");

/**
 * @deprecated Don't use this. Please. I wrote this to hack around other
 *             deprecated code, but I want to delete this too. Instead, lift
 *             state into a dedicated component or use General Store's
 *             `useStoreDependency` inside of a hooks-based functional
 *             component.
 */
function createStatefulWrapper(initialState, Component) {
  function WrapperComponent(props) {
    var _React$useState = _react.default.useState(initialState),
        _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
        state = _React$useState2[0],
        _setState = _React$useState2[1];

    var stateCallbacks = _react.default.useRef((0, _immutable.List)());

    var setState = _react.default.useCallback(function (newStateOrUpdater, afterUpdate) {
      if (typeof afterUpdate === 'function') {
        stateCallbacks.current = stateCallbacks.current.push(afterUpdate);
      }

      var newState = (0, _extends2.default)({}, state);

      if (typeof newStateOrUpdater === 'function') {
        newState = (0, _extends2.default)({}, newState, newStateOrUpdater(newState));
      } else if ((0, _typeof2.default)(newStateOrUpdater) === 'object') {
        newState = (0, _extends2.default)({}, newState, newStateOrUpdater);
      }

      _setState(newState);
    }, [state]);

    _react.default.useEffect(function () {
      stateCallbacks.current.forEach(function (cb) {
        return cb(state);
      });
      stateCallbacks.current = (0, _immutable.List)();
    }, [state]);

    return _react.default.createElement(Component, (0, _extends2.default)({}, props, {
      state: state,
      setState: setState
    }));
  }

  var displayName = Component.displayName || Component.name || 'ConnectedComponent';
  WrapperComponent.displayName = "Stateful(" + displayName + ")";
  WrapperComponent.WrappedComponent = Component;
  return WrapperComponent;
}

var _default = createStatefulWrapper;
exports.default = _default;
module.exports = exports.default;